import React, { useState } from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import SBoxTable from "./sbox";

const Verify = ({
  allEncResults,
  setVerificationState,
  incrementRoundAndCounter,
  decrementRoundAndCounter,
}) => {
  const [inputs, setInputs] = useState(["", "", "", ""]);
  const [input1, setInput1] = useState("");
  const [verificationResult, setVerificationResult] = useState("");
  let round = 3;

  const handleVerify = () => {
    if (input1.toUpperCase() === allEncResults[2][round - 1][3].join(" ")) {
      setVerificationResult("Verification successful! Click on Next again");
      setVerificationState(true);
      incrementRoundAndCounter();
    } else {
      setVerificationResult("Verification failed. Try again.");
    }
  };

  const transposedData1 = allEncResults[4][round - 2].map((col, columnIndex) =>
    allEncResults[4][round - 2].map((row) => row[columnIndex])
  );

  const sBoxData = [
    [
      "63",
      "7C",
      "77",
      "7B",
      "F2",
      "6B",
      "6F",
      "C5",
      "30",
      "01",
      "67",
      "2B",
      "FE",
      "D7",
      "AB",
      "76",
    ],
    [
      "CA",
      "82",
      "C9",
      "7D",
      "FA",
      "59",
      "47",
      "F0",
      "AD",
      "D4",
      "A2",
      "AF",
      "9C",
      "A4",
      "72",
      "C0",
    ],
    [
      "B7",
      "FD",
      "93",
      "26",
      "36",
      "3F",
      "F7",
      "CC",
      "34",
      "A5",
      "E5",
      "F1",
      "71",
      "D8",
      "31",
      "15",
    ],
    [
      "04",
      "C7",
      "23",
      "C3",
      "18",
      "96",
      "05",
      "9A",
      "07",
      "12",
      "80",
      "E2",
      "EB",
      "27",
      "B2",
      "75",
    ],
    [
      "09",
      "83",
      "2C",
      "1A",
      "1B",
      "6E",
      "5A",
      "A0",
      "52",
      "3B",
      "D6",
      "B3",
      "29",
      "E3",
      "2F",
      "84",
    ],
    [
      "53",
      "D1",
      "00",
      "ED",
      "20",
      "FC",
      "B1",
      "5B",
      "6A",
      "CB",
      "BE",
      "39",
      "4A",
      "4C",
      "58",
      "CF",
    ],
    [
      "D0",
      "EF",
      "AA",
      "FB",
      "43",
      "4D",
      "33",
      "85",
      "45",
      "F9",
      "02",
      "7F",
      "50",
      "3C",
      "9F",
      "A8",
    ],
    [
      "51",
      "A3",
      "40",
      "8F",
      "92",
      "9D",
      "38",
      "F5",
      "BC",
      "B6",
      "DA",
      "21",
      "10",
      "FF",
      "F3",
      "D2",
    ],
    [
      "CD",
      "0C",
      "13",
      "EC",
      "5F",
      "97",
      "44",
      "17",
      "C4",
      "A7",
      "7E",
      "3D",
      "64",
      "5D",
      "19",
      "73",
    ],
    [
      "60",
      "81",
      "4F",
      "DC",
      "22",
      "2A",
      "90",
      "88",
      "46",
      "EE",
      "B8",
      "14",
      "DE",
      "5E",
      "0B",
      "DB",
    ],
    [
      "E0",
      "32",
      "3A",
      "0A",
      "49",
      "06",
      "24",
      "5C",
      "C2",
      "D3",
      "AC",
      "62",
      "91",
      "95",
      "E4",
      "79",
    ],
    [
      "E7",
      "C8",
      "37",
      "6D",
      "8D",
      "D5",
      "4E",
      "A9",
      "6C",
      "56",
      "F4",
      "EA",
      "65",
      "7A",
      "AE",
      "08",
    ],
    [
      "BA",
      "78",
      "25",
      "2E",
      "1C",
      "A6",
      "B4",
      "C6",
      "E8",
      "DD",
      "74",
      "1F",
      "4B",
      "BD",
      "8B",
      "8A",
    ],
    [
      "70",
      "3E",
      "B5",
      "66",
      "48",
      "03",
      "F6",
      "0E",
      "61",
      "35",
      "57",
      "B9",
      "86",
      "C1",
      "1D",
      "9E",
    ],
    [
      "E1",
      "F8",
      "98",
      "11",
      "69",
      "D9",
      "8E",
      "94",
      "9B",
      "1E",
      "87",
      "E9",
      "CE",
      "55",
      "28",
      "DF",
    ],
    [
      "8C",
      "A1",
      "89",
      "0D",
      "BF",
      "E6",
      "42",
      "68",
      "41",
      "99",
      "2D",
      "0F",
      "B0",
      "54",
      "BB",
      "16",
    ],
  ];

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data = allEncResults[1][round - 1].toString().split(" ");
  console.log("data", data);

  let cols2 = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];

  const renderTable2 = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols2[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  return (
    <>
      <div className="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Verification of Round 3</h2>
        <p className="pb-5">
          Now calculate the following Values for Round 3 and enter it below (It
          should be the hex values with spaces)
        </p>

        <div className="grid grid-flow-col grid-cols-5 gap-2 align-middle pt-28">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className="bg-emerald-100 rounded-xl w-auto border hover:border-cyan-500">
              <tbody>
                {/* Map through the transposed data and create rows for each column */}
                {transposedData1.map((column, columnIndex) => (
                  <tr key={columnIndex}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {/* Join the characters in each item and display in a single row */}
                        {column
                          .map((item) => item.split("").join(""))
                          .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 ")}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="align-middle">
              {" "}
              After XOR(Final o/p of Previous round)
            </p>
          </motion.div>

          <div className=" pt-20 pl-7">
            <svg
              width="170"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <motion.path
                variants={icon}
                initial="hidden"
                animate="visible"
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className=" bg-emerald-100 rounded-xl w-auto">
              <tbody className="">{renderTable2()}</tbody>
            </table>
            <p className="align-middle"> After S-box substition</p>
          </motion.div>

          <div className=" pt-20 pl-7">
            <svg
              width="170"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <motion.path
                variants={icon}
                initial="hidden"
                animate="visible"
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className=" bg-emerald-100 rounded-xl w-auto">
              <tbody className="">
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">
                      {allEncResults[2][round - 1][0]
                        .map((item) => item.split("").join(""))
                        .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {allEncResults[2][round - 1][1]
                      .map((item) => item.split("").join(""))
                      .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(0, 25)}

                    {allEncResults[2][round - 1][1]
                      .map((item) => item.split("").join(""))
                      .join(" ")
                      .slice(9, 13)}
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {allEncResults[2][round - 1][2]
                      .map((item) => item.split("").join(""))
                      .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(0, 15)}
                    {allEncResults[2][round - 1][2]
                      .map((item) => item.split("").join(""))
                      .join("\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(15, 26)}
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {/* <div className="text-sm text-gray-900">{allEncResults[2][round-1][3].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div> */}
                    <input
                      type="text"
                      value={input1}
                      onChange={(e) => setInput1(e.target.value)}
                    ></input>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="align-middle"> After Shifted Rows</p>
          </motion.div>
        </div>

        <div className="next-button" onClick={handleVerify}>
          NEXT
        </div>

        {/* <div className="button-holder">
        <div className="prev-button" onClick={decrementRoundAndCounter}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={handleVerify}>
          NEXT
        </div>
      </div> */}
        <p className="mt-2">{verificationResult}</p>
      </div>
      <div className="grid grid-cols-3 gap-8 content-center pt-4 px-4">
        <div></div>
      </div>
    </>
  );
};

export default Verify;
